import React from 'react';
import { TaskType, useSmartTagsService } from 'nekst-api';
import SmartTagsContext from './SmartTagsContext';

export function ProjectSmsSmartTagsContext(
  props: {
    children: React.ReactElement,
    projectId?: number,
  }
) {
  const smartTagsService = useSmartTagsService();

  return (
    <SmartTagsContext
      getTagsFunc={
        async () => {
          if (props.projectId) {
            return smartTagsService.getSmartTagsByProjectId(props.projectId, TaskType.SMS);
          } else {
            return [];
          }
        }
      }
      dependencies={[props.projectId]}
    >
      {props.children}
    </SmartTagsContext>
  );
}

export function PlanSmsSmartTagsContext(
  props: {
    children: React.ReactElement,
    planId: number,
  }
) {
  const smartTagsService = useSmartTagsService();

  return (
    <SmartTagsContext
      getTagsFunc={
        () => smartTagsService.getSmartTagsByPlanId(props.planId, TaskType.SMS)
      }
      dependencies={[
        props.planId
      ]}
    >
      {props.children}
    </SmartTagsContext>
  );
}
